/**
 * 基础路由
 * @type { *[] }
 */
export const constantRouterMap = [
  {
    path: '/',
    component: () => import('@/views/home'),
    redirect: '/index',
    meta: {
      navColor: true,
      title: '吉林体彩网-吉林省体育彩票管理中心官方网站',
      keepAlive: false,
    },
    children: [
      {
        path: '/index',
        name: 'index',
        component: () => import('@/views/index/index'),
        meta: {
          navColor: true,
          title: '吉林体彩网-吉林省体育彩票管理中心官方网站',
          keepAlive: false,
          requireAuth: false,
          openInNewTab: true
        }
      },
      {
        path: '/newsList',
        name: 'newsList',
        component: () => import('@/views/article/newsList'),
        meta: {
          navColor: true,
          title: '吉林体彩网-吉林省体育彩票管理中心官方网站',
          keepAlive: false,
          requireAuth: false,
          openInNewTab: true
        }
      },
      {
        path: '/articleList',
        name: 'articleList',
        component: () => import('@/views/article/articleList'),
        meta: {
          navColor: true,
          title: '吉林体彩网-吉林省体育彩票管理中心官方网站',
          keepAlive: false,
          requireAuth: false,
          openInNewTab: true
        }
      },
      {
        path: '/newsDetails',
        name: 'newsDetails',
        component: () => import('@/views/article/newsDetails'),
        meta: {
          navColor: true,
          title: '吉林体彩网-吉林省体育彩票管理中心官方网站',
          keepAlive: false,
          requireAuth: false,
          openInNewTab: true
        }
      },
      {
        path: '/searchList',
        name: 'searchList',
        component: () => import('@/views/article/searchList'),
        meta: {
          navColor: true,
          title: '吉林体彩网-吉林省体育彩票管理中心官方网站',
          keepAlive: false,
          requireAuth: false,
          openInNewTab: true
        }
      },
      {
        path: '/videoList',
        name: 'videoList',
        component: () => import('@/views/article/videoList'),
        meta: {
          navColor: true,
          title: '吉林体彩网-吉林省体育彩票管理中心官方网站',
          keepAlive: false,
          requireAuth: false,
          openInNewTab: true
        }
      },
      {
        path: '/videoDetails',
        name: 'videoDetails',
        component: () => import('@/views/article/videoDetails'),
        meta: {
          navColor: true,
          title: '吉林体彩网-吉林省体育彩票管理中心官方网站',
          keepAlive: false,
          requireAuth: false,
          openInNewTab: true
        }
      },
      {
        path: '/ticketDetails',
        name: 'ticketDetails',
        component: () => import('@/views/article/ticketDetails'),
        meta: {
          navColor: true,
          title: '吉林体彩网-吉林省体育彩票管理中心官方网站',
          keepAlive: false,
          requireAuth: false,
          openInNewTab: true
        }
      },
      {
        path: '/ticketList',
        name: 'ticketList',
        component: () => import('@/views/article/ticketList'),
        meta: {
          navColor: true,
          title: '吉林体彩网-吉林省体育彩票管理中心官方网站',
          keepAlive: false,
          requireAuth: false,
          openInNewTab: true
        }
      },
      {
        path: '/adout',
        name: 'adout',
        component: () => import('@/views/article/adout'),
        meta: {
          navColor: true,
          title: '吉林体彩网-吉林省体育彩票管理中心官方网站',
          keepAlive: false,
          requireAuth: false,
          openInNewTab: true
        }
      }
      // {
      //   path: '/report',
      //   name: 'report',
      //   component: () => import('@/views/report/report'),
      //   meta: {
      //     navColor: true,
      //     title: '吉林体彩网-吉林省体育彩票管理中心官方网站',
      //     keepAlive: false,
      //     requireAuth: false
      //   }
      // },
    ]
  }
]
